import React from 'react';

const EventValidationContainer = ({ event }) => {
  return <div>Event Validations</div>;
};

export default EventValidationContainer;
